<template>
<div class="card float-e-margins">
  <div class="card-title">
      <h1>Gastenboek</h1>
  </div>
  <div class="card-content no-padding">
    <div class="row">
      <form class="form-horizontal" name="contact-form" v-on:submit.prevent="SubmitForm">
        <div class="form-group">
          <label for="name" class="col-sm-1 control-label">Naam</label>
          <div class="col-sm-8">
            <input type="text" v-model="review.Name" class="form-control" id="name" name="name" placeholder="Voor- en Achternaam" required>
          </div>
        </div>
        <div class="form-group">
          <label for="message" class="col-sm-1 control-label">Bericht</label>
          <div class="col-sm-8">
            <textarea class="form-control" v-model="review.Content" rows="4" name="message" required></textarea>
          </div>
        </div>
        <div class="form-group">
          <label for="score" class="col-sm-1 control-label">Beoordeling</label>
          <div class="col-sm-1">
          <select class="form-control" id="sel1" name="score" v-model="review.Rating" >
            <option selected>5</option>
            <option>4</option>
            <option>3</option>
            <option>2</option>
            <option>1</option>
          </select>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-4 col-sm-offset-8">
            <input id="submit" name="submit" type="submit" value="Verzend" class="btn btn-primary">
          </div>
        </div>
        <!-- after save start -->
        <vc-alert v-if="success" type="success" :dismissible="false">
          Succesvol verzonden! Na goedkeuring verschijnt je reactie hieronder.
        </vc-alert>
        <vc-alert v-if="error" type="danger" :dismissible="false">
           {{errorMessage}}
        </vc-alert>
        <!-- after save end -->
      </form>
    </div> 
    <div class="row">
      <div class="col-md-12">
        <hr/>
        <div class="review-block">
          <div class="row" v-for="rvw in reviews">
            <div class="col-sm-3">
              <div class="review-block-name">{{rvw.Name}}</div>
              <div class="review-block-date">{{rvw.DateSubmitted}}</div>
            </div>
            <div class="col-sm-9">
              <div class="review-block-rate">
                <button v-for="n in rvw.Rating" type="button" class="btn btn-warning btn-xs" aria-label="Left Align">
                  <span class="glyphicon glyphicon-star" aria-hidden="true"></span>
                </button>
              </div>
              <div class="review-block-description">{{rvw.Content}}</div>
            </div>
          </div>
          <hr/>
        </div>
      </div>
    </div>   
  </div>
</div>
</template>
<script>
import callbackalert from './Common/CallbackAlert'
import store from '../store'

export default {
  components: {
    'vc-alert': callbackalert,
    store: store
  },
  data () {
    return {
      reviews: {},
      review: {
        Name: '',
        Content: '',
        Rating: 5
      },
      error: false,
      success: false,
      isValid: true
    }
  },
  methods: {
    onVerify: function (response) {
      this.error = false
      this.isValid = true
      console.log('Verify: ' + response)
    },
    onExpired: function () {
      console.log('reCAPTHA Expired')
    },
    SubmitForm: function () {
      if (!this.isValid) {
        this.error = true
        this.errorMessage = 'Valideer je gegevens!'
      } else {
        $.ajax({
          type: 'POST',
          url: store.root + 'api/Reviews',
          data: this.review,
          xhrFields: {
            withCredentials: true
          }
        }).done(function () {
          this.success = true
          this.error = false
          this.review = {}
        }.bind(this))
        .fail(function (response) {
          console.log(response)
          this.success = false
          this.error = true
          this.errorMessage = 'Er is een fout opgetreden, probeer later opnieuw!'
        }.bind(this))
      }
    },
    getReviews: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/reviews',
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.reviews = response
        }.bind(this)
      })
    }
  },
  created () {
    this.getReviews()
  }
}
</script>



// WEBPACK FOOTER //
// Gastenboek.vue?0aa83e90